<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="openDialog" scrollable max-width="500px">
        <v-form id='alertCreateForm'>
          <v-card>
            <v-card-title>
              <span class="headline">
                {{ $t('Manual Alert') }}
              </span>
            </v-card-title>
            <v-card-text class="manual-alert-dialog">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-menu v-model="timeMenu" :close-on-content-click="false" :nudge-right="40" lazy
                      transition="scale-transition" full-width min-width="290px">
                      <v-text-field slot="activator" v-model="manualAlert.currentTime" :label="`${$t('Start Time')}*`"
                        prepend-icon="access_time" readonly></v-text-field>
                      <v-time-picker v-model="manualAlert.currentTime" full-width
                        @click:minute="$refs.menu.save(manualAlert.currentTime)"></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12>
                    <v-menu v-model="dateMenu" :close-on-content-click="true" :nudge-right="0" lazy
                      transition="scale-transition" offset-y full-width min-width="290px">
                      <v-text-field slot="activator" v-model="manualAlert.currentDate" :label="`${$t('Start Date')}*`"
                        prepend-icon="event" readonly></v-text-field>
                      <v-date-picker v-model="manualAlert.currentDate" @input="dateMenu = false"></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12>
                    <v-select prepend-icon="smartphone" :items="[{ text: $t('computed'), value: 'computed' }]"
                      v-model="manualAlert.equipment" :label="`${$t('Equipment')}*`"
                      item-text="text" item-value="value" required></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea prepend-icon="chat" :label="`${$t('Message')}*`" row-height=10 no-resize
                      v-model="manualAlert.reason" :hint="$t('Alert Message')" required>
                    </v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <v-select prepend-icon="warning" :items="[{ text: $t('Manual Alert'), value: 'Manual Alert' }, { text: $t('Dip Reason'), value: 'Dip Reason' }]"
                      v-model="manualAlert.code" :label="`${$t('Code')}*`" item-text="text" item-value="value" required></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="openDialog = false">{{ $t('Cancel') }}</v-btn>
              <v-btn color="blue darken-1" type="button" flat @click="openDialog = false; createMAlert()"
                :disabled="disableBtn">{{ $t('Send') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
const momentTz = require('moment-timezone')
import { v4 as uuidv4 } from 'uuid'
import { mapGetters } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      timeMenu: null,
      dateMenu: false,
      manualAlert: this.currentData()
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getActivePlantTimezone']),
    openDialog: {
      get() {
        return this.open
      },
      set(value) {
        this.$emit('change:state', value)
      }
    },
    disableBtn() {
      let {
        currentDate,
        currentTime,
        equipment,
        code,
        reason
      } = this.manualAlert
      if (reason.trim().length <= 0 ||
        currentTime.trim().length <= 0 ||
        currentDate.trim().length <= 0 ||
        code.trim().length <= 0 ||
        equipment.trim().length <= 0
      ) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    createMAlert() {
      let {
        currentDate,
        currentTime,
        equipment,
        code,
        reason
      } = this.manualAlert
      
      const unixTime = momentTz(`${currentDate} ${currentTime}`, 'YYYY-MM-DD HH:mm').tz(this.getActivePlantTimezone).format('X')
      let query = {
        plant_id: this.getSelectedPlantId,
        ref_id: uuidv4(),
        sensor_time: unixTime,
        status: 'new',
        severity: 99,
        scope: 'MA', // Manual Alert
        logic: 'secondary',
        equipment_id: 1,
        created_timestamp: unixTime,
        created_date: currentDate,
        equipment: equipment,
        code: code,
        message: reason
      }

      this.$mqtt.publish('/alert/live', JSON.stringify(query))
      this.manualAlert = this.currentData()
    },
    currentData() {
      return {
        currentTime: '',
        currentDate: '',
        reason: '',
        code: '',
        equipment: ''
      }
    }
  }
}
</script>

<style scoped>
.manual-alert-dialog{
  height: 300px; 
}
</style>
